import * as Types from '../../types';

export const getSelectLabel = (options: Types.TSelectOptions, value: string, defaultValue?: string): string | undefined => {
    const option = options.find((element) => element.value === value);

    return option?.label || defaultValue;
};

export const parseOptions = (options: string | Types.TSelectOptions): Types.TSelectOptions => {
    let resultedOptions = options as Types.TSelectOptions;

    if (typeof options === 'string' && options.length) {
        try {
            resultedOptions = JSON.parse(options.replaceAll('\'', '"'));
        // eslint-disable-next-line no-empty
        } catch {}

        return resultedOptions;
    }

    return resultedOptions;
};
